// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"3b53517f","2647":"3b53517f","7664":"3b53517f"}[chunkId] + ".chunk.css";
};